import {
  PAYMENT_FAIL_FAIL,
  PAYMENT_FAIL_RESET,
  PAYMENT_FAIL_START,
  PAYMENT_FAIL_SUCCESS,
} from "./constants";
import {PaymentFailActions, PaymentFailState} from "./types";

const initialState: PaymentFailState = {
  loading: false,
  data: undefined,
  error: undefined,
}

const reducer = (
  state = initialState,
  action: PaymentFailActions,
): PaymentFailState => {
  switch (action.type) {
    case PAYMENT_FAIL_START:
      return {
        ...initialState,
        loading: true,
      }
    case PAYMENT_FAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case PAYMENT_FAIL_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      }
    case PAYMENT_FAIL_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
